import React from "react";

import { toSelectableCropDropdownOptions, useCropList } from "~/admin/setup/customer/use-crop-list";
import { useLoggedInUserProductScopeOrgLevelGuid } from "~/admin/setup/customer/use-product-list";

import AddEditPanelContainer from "../../../containers/add-edit-panel";
import AddEditPanel from "./add-edit-panel";
import { pickLists, unitTypes, service, dropdowns, model } from "../data";

const ConnectedAddEditPanel = AddEditPanelContainer(AddEditPanel, {
    pickLists,
    unitTypes,
    service,
    dropdowns,
});

const AddEditContainer = (props) => {
    const orgLevelGuid = useLoggedInUserProductScopeOrgLevelGuid();
    const { crops } = useCropList({ orgLevelGuid });

    return (
        <ConnectedAddEditPanel
            {...props}
            {...{ [model.PROPS_CROP_LIST]: toSelectableCropDropdownOptions(crops) }}
        />
    );
};

export default AddEditContainer;
